// extracted by mini-css-extract-plugin
export default {"icon":"ProvisionEntitySearchPostPill-module__icon--h1jAa"};